const isCategoryValue = (value: unknown): value is { value: string } =>
	typeof value === 'object' && value !== null && typeof (value as { value?: unknown }).value === 'string';

export const transformApiCategoryValuesToAppStrings = (input: unknown): string[] => {
	if (!Array.isArray(input) || !input.every(isCategoryValue)) {
		throw new Error('Invalid category value entities');
	}
	return [...new Set(input.map((item) => item.value))];
};
